import { defineComponent as c, createBlock as n, openBlock as o, unref as r, mergeProps as p, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ c({
  name: "IconReassuranceShieldFilled",
  __name: "IconReassuranceShieldFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (m, a) => (o(), n(r(i), p(t, { "view-box": "0 0 48 48" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#wk9g4a)",
          "clip-rule": "evenodd"
        }, [
          e("path", { d: "M12.584 9.769 10.16 23.516c-.96 5.447 1.693 9.764 4.662 12.761a26.695 26.695 0 0 0 6.033 4.522l.003.002h.004a15.936 15.936 0 0 0 .451-.071 26.697 26.697 0 0 0 6.764-2.116c3.816-1.8 7.785-4.95 8.745-10.396l2.425-13.752c-2.82.601-4.924.363-6.873-.459-1.758-.74-3.378-1.957-5.255-3.367a268.433 268.433 0 0 0-.834-.625 213.986 213.986 0 0 0-1.077.32c-2.247.669-4.18 1.245-6.067 1.34-2.11.104-4.15-.387-6.557-1.906m15.93 12.096c-.303.83-.892 1.383-1.287 1.235-.396-.148-.481-.949-.168-1.777.313-.828.892-1.384 1.286-1.226.394.158.482.94.17 1.768m2.556 2.54c-.42-.073-.602-.87-.412-1.73.191-.86.685-1.49 1.112-1.404.427.085.602.871.41 1.74-.193.87-.657 1.495-1.11 1.395m-8.21-2.428a.329.329 0 0 1 .423.163 13.368 13.368 0 0 0 1.168 2.169 9.123 9.123 0 0 0 1.583 1.77 9.232 9.232 0 0 0 4.386 2.011.32.32 0 1 1-.063.637 8.245 8.245 0 0 1-2.627-.463 8.093 8.093 0 0 1-3.328-2.285 7.533 7.533 0 0 1-.784-1.12 6.864 6.864 0 0 1-.912-2.566.338.338 0 0 1 .183-.311l-.029-.005" }),
          e("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91m15.578 4.94a.5.5 0 0 1 .437.079C27.048 9.336 27.4 9.6 27.74 9.854c1.883 1.414 3.388 2.543 5.023 3.232 1.885.794 3.958 1.004 6.986.236a.5.5 0 0 1 .615.572l-.492-.087.492.087-2.556 14.497c-1.04 5.902-5.345 9.26-9.303 11.128A27.696 27.696 0 0 1 21 41.79a10.943 10.943 0 0 1-.128.017l-.035.004-.012.001-.058-.496-.224.447-.003-.002-.008-.004-.031-.016a17.335 17.335 0 0 1-.54-.294 27.698 27.698 0 0 1-5.85-4.468c-3.08-3.108-5.976-7.735-4.936-13.637l2.557-14.498.492.087-.492-.087a.5.5 0 0 1 .776-.325c2.54 1.749 4.54 2.257 6.583 2.155 1.756-.087 3.552-.622 5.801-1.29a189.206 189.206 0 0 1 1.352-.4m-5.477 32.332.057.496a.502.502 0 0 1-.28-.05l.223-.446" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "wk9g4a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
